import React, { useCallback, useState } from 'react'
import { Flex } from 'reflexbox'
import styled from 'styled-components'

import Modal from './Modal'
import Card from 'components/Card'
import Button from 'components/Button'
import { Text, SemiTitle } from 'components/Typography'
import { Close } from 'components/Icons'

import { activateBeneficiary } from 'services/beneficiaries'

import theme from 'styles/theme'
import { toast } from 'react-toastify'
import Loader from 'components/Loader'

const ActivateModal = ({ isOpened, setIsOpened, beneficiary }) => {
  const [isLoading, setIsLoading] = useState(false)

  const beneficiaryAction = useCallback(async () => {
    try {
      setIsLoading(true)
      await activateBeneficiary(beneficiary?.id, beneficiary?.is_active ? 'deactivate' : 'activate')
      toast.success(`Beneficiário ${beneficiary?.is_active ? 'desativado' : 'ativado'} com sucesso.`)
      setIsOpened(false)
    } catch (e) {
      console.log(e)
      toast.error(`Não foi possivel ${beneficiary?.is_active ? 'desativar' : 'ativar'} o beneficiário.`)
    } finally {
      setIsLoading(false)
    }
  }, [beneficiary])

  return (
    <Modal isOpened={isOpened} setIsOpened={setIsOpened}>
      <Card bg={theme.colors.white} minWidth={588}>
        <Flex flexDirection='column'>
          <Flex width={1} justifyContent='space-between' mb={16}>
            <SemiTitle>{beneficiary?.is_active ? 'Desativar' : 'Ativar'} beneficiário</SemiTitle>
            <CloseButton onClick={() => setIsOpened(false)}>
              <Close />
            </CloseButton>
          </Flex>

          <Text>Tem certeza que quer {beneficiary?.is_active ? 'desativar' : 'ativar'} este beneficiário?</Text>

          <Flex mt={24} width={1} justifyContent='flex-end'>
            <Button
              mr={24}
              outlined
              variant={beneficiary?.is_active ? 'tertiary' : 'primary'}
              onClick={() => setIsOpened(false)}
            >
              Cancelar
            </Button>
            <Button
              variant={beneficiary?.is_active ? 'tertiary' : 'primary'}
              disabled={isLoading}
              onClick={beneficiaryAction}
            >
              {isLoading ? <Loader /> : beneficiary?.is_active ? 'Desativar' : 'Ativar'}
            </Button>
          </Flex>
        </Flex>
      </Card>
    </Modal>
  )
}

const CloseButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
`

export default ActivateModal
